import { PUBLIC_ESTATE_FILTERS } from '../constants';

import { getStrapiEstates } from './getStrapiEstates';

import type { Locales, StrapiPaginationByPageParams } from '@monoimin/sb-types';

import type { GetStrapiEstatesResponse } from '../types';

export async function getAllEstates(
  { page, pageSize = 50 }: StrapiPaginationByPageParams,
  locale: Locales
): Promise<GetStrapiEstatesResponse> {
  try {
    return await getStrapiEstates({
      pagination: { page: page ?? 1, pageSize },
      fields: ['slug', 'country_slug', 'publishedAt'],
      populate: '',
      locale,
      filters: PUBLIC_ESTATE_FILTERS,
    });
  } catch (err) {
    return { estates: [], totalCount: 0 };
  }
}

export default getAllEstates;
